import { useCallback } from 'react';

import { useUserAuth } from '~/components/Auth';

import { DEAFAULT_PROP_GENERATOR } from '../config/constants';

import useCasl from '../hooks/useCasl';
import { getCaslAbility } from '../helpers';

import type { TPermissions, TCasl } from '../types';

const withAbility = <Props extends { casl: TCasl }>(propGenerator = DEAFAULT_PROP_GENERATOR) => (
  Component: React.ComponentType<Props>
) => (props: Props) => {
  const { contextPermissions } = propGenerator(props);
  const casl = useCasl(contextPermissions);
  const { permissions } = useUserAuth();

  const getScopedCasl = useCallback(
    (scopedPermissions: TPermissions) => {
      const ability = getCaslAbility(permissions, scopedPermissions);
      return ability;
    },
    [permissions]
  );

  return <Component {...props} casl={casl} getScopedCasl={getScopedCasl} />;
};

export default withAbility;
